import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { localize } from 'core/localization';
import Trophy from 'assets/figures/Trophy';
import { Text, Button } from 'components/common';
import { Figure, TextElement, ButtonsWrapper, Wrapper } from './ThankForFeedback.styled';

export class ThankForFeedback extends PureComponent {
  render() {
    const { fromDownloadCertificateButton, backTo, closeCourse, isScormMode } = this.props;
    return (
      <Wrapper>
        <Figure>
          <Trophy />
        </Figure>
        <Text appearance="h3">{localize('[thank for feedback]')}</Text>
        {!isScormMode && !fromDownloadCertificateButton && (
          <TextElement appearance="p" size={14} font="secondaryFont">
            {localize('[you can close the page]')}
          </TextElement>
        )}

        {isScormMode && (
          <Button onClick={closeCourse} layout="secondary">
            {localize('[close course]')}
          </Button>
        )}
        {fromDownloadCertificateButton && (
          <ButtonsWrapper>
            <Button onClick={backTo} layout="primary">
              {localize('[back to the results]')}
            </Button>
            <Button onClick={closeCourse} layout="secondary">
              {localize('[close course]')}
            </Button>
          </ButtonsWrapper>
        )}
      </Wrapper>
    );
  }
}

ThankForFeedback.propTypes = {
  backTo: PropTypes.func.isRequired,
  closeCourse: PropTypes.func.isRequired,
  fromDownloadCertificateButton: PropTypes.bool,
  isScormMode: PropTypes.bool
};

ThankForFeedback.defaultProps = {
  fromDownloadCertificateButton: false,
  isScormMode: false
};

export default ThankForFeedback;
